export default __webpack_public_path__ + "static/media/Events.655e8a13.svg";